import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert, Spinner, Table, Badge } from 'react-bootstrap';
import { FaUserTie, FaCheck, FaTrash, FaSearch } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import permisosApi from '../../../services/api/permisosApi';
import usuarioApi from '../../../services/api/usuarioApi';
import pythonApiClient from '../../../services/api/pythonBaseApi';
import 'react-toastify/dist/ReactToastify.css';

const AsignarRolesUsuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [roles, setRoles] = useState([]);
  const [asignaciones, setAsignaciones] = useState([]);
  const [selectedUsuario, setSelectedUsuario] = useState(null);
  const [selectedRol, setSelectedRol] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    loadUsuarios();
    loadRoles();
    loadAsignaciones();
  }, []);

  const loadUsuarios = async () => {
    setLoading(true);
    try {
      const response = await usuarioApi.getAll();
      if (response.data) {
        setUsuarios(Array.isArray(response.data) ? response.data : [response.data]);
      }
    } catch (error) {
      console.error('Error al cargar usuarios:', error);
      toast.error('Error al cargar usuarios');
    } finally {
      setLoading(false);
    }
  };

  const loadRoles = async () => {
    try {
      const response = await permisosApi.getRoles();
      if (response.data) {
        setRoles(Array.isArray(response.data) ? response.data : [response.data]);
      }
    } catch (error) {
      console.error('Error al cargar roles:', error);
      toast.error('Error al cargar roles');
    }
  };


  const loadAsignaciones = async () => {
    setLoading(true);
    try {
      console.log('🔍 [loadAsignaciones] Iniciando carga de asignaciones...');
      console.log('📍 [loadAsignaciones] Usando pythonApiClient');
      console.log('📍 [loadAsignaciones] baseURL:', pythonApiClient.defaults.baseURL);
      
      const response = await pythonApiClient.get('/seguridad/permisos/usuarios-roles');
      
      console.log('📥 [loadAsignaciones] Respuesta recibida:');
      console.log('   - Status:', response.status);
      console.log('   - Data:', response.data);
      
      const data = response.data;
      
      // Manejar si la respuesta es un objeto con 'data' o directamente un array
      if (Array.isArray(data)) {
        setAsignaciones(data);
        console.log('✅ [loadAsignaciones] Asignaciones cargadas:', data.length);
      } else if (data.data && Array.isArray(data.data)) {
        setAsignaciones(data.data);
        console.log('✅ [loadAsignaciones] Asignaciones cargadas desde data.data:', data.data.length);
        if (data.message) {
          toast.warning(data.message);
        }
      } else if (data.message) {
        // Si hay un mensaje pero no datos, mostrar el mensaje
        setAsignaciones([]);
        console.log('⚠️ [loadAsignaciones] Mensaje recibido:', data.message);
        toast.warning(data.message);
      } else {
        setAsignaciones([]);
        console.log('⚠️ [loadAsignaciones] Respuesta vacía o formato desconocido');
      }
    } catch (error) {
      console.error('❌ [loadAsignaciones] Error:', error);
      console.error('   - Tipo:', error.name);
      console.error('   - Mensaje:', error.message);
      console.error('   - Response:', error.response?.data);
      console.error('   - Status:', error.response?.status);
      
      const errorMessage = error.response?.data?.detail || 
                          error.response?.data?.message || 
                          error.response?.data?.error || 
                          error.message || 
                          'Error desconocido';
      toast.error(`Error al cargar asignaciones: ${errorMessage}`);
    } finally {
      setLoading(false);
      console.log('🏁 [loadAsignaciones] Finalizado');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!selectedUsuario || !selectedRol) {
      toast.error('Por favor seleccione usuario y rol');
      return;
    }

    setSaving(true);
    try {
      console.log('🔍 [handleSubmit] Asignando rol...');
      console.log('   - Usuario ID:', selectedUsuario);
      console.log('   - Rol ID:', selectedRol);
      
      const response = await pythonApiClient.post('/seguridad/permisos/usuarios-roles', {
        id_user: parseInt(selectedUsuario),
        rol_id: parseInt(selectedRol)
      });

      console.log('✅ [handleSubmit] Rol asignado correctamente:', response.data);
      toast.success('Rol asignado correctamente');
      setSelectedUsuario(null);
      setSelectedRol(null);
      loadAsignaciones();
    } catch (error) {
      console.error('❌ [handleSubmit] Error:', error);
      console.error('   - Response:', error.response?.data);
      const errorMessage = error.response?.data?.detail || 
                          error.response?.data?.message || 
                          error.response?.data?.error || 
                          error.message || 
                          'Error desconocido';
      toast.error(`Error al asignar rol: ${errorMessage}`);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (asignacionId) => {
    if (!window.confirm('¿Está seguro de que desea eliminar esta asignación?')) {
      return;
    }

    setLoading(true);
    try {
      console.log('🔍 [handleDelete] Eliminando asignación:', asignacionId);
      
      await pythonApiClient.delete(`/seguridad/permisos/usuarios-roles/${asignacionId}`);

      console.log('✅ [handleDelete] Asignación eliminada correctamente');
      toast.success('Asignación eliminada correctamente');
      loadAsignaciones();
    } catch (error) {
      console.error('❌ [handleDelete] Error:', error);
      console.error('   - Response:', error.response?.data);
      const errorMessage = error.response?.data?.detail || 
                          error.response?.data?.message || 
                          error.response?.data?.error || 
                          error.message || 
                          'Error desconocido';
      toast.error(`Error al eliminar asignación: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  };

  const filteredAsignaciones = asignaciones.filter(asignacion => {
    if (!asignacion) return false;
    const searchLower = searchTerm.toLowerCase();
    return (
      asignacion.usuario_nombre?.toLowerCase().includes(searchLower) ||
      asignacion.usuario_username?.toLowerCase().includes(searchLower) ||
      asignacion.rol_nombre?.toLowerCase().includes(searchLower)
    );
  });

  return (
    <Container fluid className="py-4">
      <ToastContainer />
      <Row>
        <Col>
          <Card>
            <Card.Header className="bg-primary text-white">
              <h4 className="mb-0">
                <FaUserTie className="me-2" />
                Asignar Roles a Usuarios
              </h4>
            </Card.Header>
            <Card.Body>
              <Row className="mb-4">
                <Col md={12}>
                  <Card className="border-primary">
                    <Card.Header className="bg-light">
                      <h5 className="mb-0">Nueva Asignación</h5>
                    </Card.Header>
                    <Card.Body>
                      <Form onSubmit={handleSubmit}>
                        <Row>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Usuario <span className="text-danger">*</span></Form.Label>
                              <Form.Select
                                value={selectedUsuario || ''}
                                onChange={(e) => setSelectedUsuario(e.target.value)}
                                required
                              >
                                <option value="">-- Seleccione un usuario --</option>
                                {usuarios.map(usuario => (
                                  <option key={usuario.id} value={usuario.id}>
                                    {usuario.nombre} {usuario.username ? `(${usuario.username})` : ''}
                                  </option>
                                ))}
                              </Form.Select>
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Rol <span className="text-danger">*</span></Form.Label>
                              <Form.Select
                                value={selectedRol || ''}
                                onChange={(e) => setSelectedRol(e.target.value)}
                                required
                              >
                                <option value="">-- Seleccione un rol --</option>
                                {roles.filter(rol => rol.activo).map(rol => (
                                  <option key={rol.id} value={rol.id}>
                                    {rol.nombre} {rol.descripcion ? `- ${rol.descripcion}` : ''}
                                  </option>
                                ))}
                              </Form.Select>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Button
                          variant="primary"
                          type="submit"
                          disabled={saving}
                        >
                          {saving ? (
                            <>
                              <Spinner size="sm" className="me-2" />
                              Guardando...
                            </>
                          ) : (
                            <>
                              <FaCheck className="me-2" />
                              Asignar Rol
                            </>
                          )}
                        </Button>
                      </Form>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Control
                    type="text"
                    placeholder="Buscar por usuario o rol..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </Col>
              </Row>

              {loading ? (
                <div className="text-center py-5">
                  <Spinner animation="border" />
                  <p className="mt-2">Cargando asignaciones...</p>
                </div>
              ) : (
                <Table responsive striped bordered hover>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Usuario</th>
                      <th>Nombre de Usuario</th>
                      <th>Rol</th>
                      <th>Estado</th>
                      <th>Fecha Asignación</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredAsignaciones.length > 0 ? (
                      filteredAsignaciones.map((asignacion) => (
                        asignacion && (
                        <tr key={asignacion.id}>
                          <td>{asignacion.id}</td>
                          <td>{asignacion.usuario_nombre || '-'}</td>
                          <td>{asignacion.usuario_username || '-'}</td>
                          <td>
                            <Badge bg="info">{asignacion.rol_nombre || '-'}</Badge>
                          </td>
                          <td>
                            <Badge bg={asignacion.activo ? 'success' : 'secondary'}>
                              {asignacion.activo ? 'Activo' : 'Inactivo'}
                            </Badge>
                          </td>
                          <td>{asignacion.created_at ? new Date(asignacion.created_at).toLocaleDateString('es') : '-'}</td>
                          <td>
                            <Button
                              variant="danger"
                              size="sm"
                              onClick={() => handleDelete(asignacion.id)}
                            >
                              <FaTrash />
                            </Button>
                          </td>
                        </tr>
                        )
                      )).filter(Boolean)
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center py-4 text-muted">
                          {searchTerm ? 'No se encontraron asignaciones que coincidan con la búsqueda' : 'No hay asignaciones registradas'}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AsignarRolesUsuarios;
